import { HttpInterceptorFn } from '@angular/common/http';

export const REQUEST_ID_HEADER = 'x-request-id';

/** Un id corto y seguro (`web-<base36>`): la API lo acepta tal cual y lo devuelve en la respuesta y en sus logs. */
export function newRequestId(): string {
  const random =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID().replace(/-/g, '').slice(0, 20)
      : Math.random().toString(36).slice(2, 14) + Date.now().toString(36);
  return `web-${random}`;
}

/** Correlaciona cada petición con los logs y `run_events` de la API. */
export const requestIdInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.headers.has(REQUEST_ID_HEADER)) return next(req);
  return next(req.clone({ setHeaders: { [REQUEST_ID_HEADER]: newRequestId() } }));
};
